/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Ashraf tuyubahe",
  title: "Hi all, I'm Ashraf",
  subTitle: emoji(
    "I’m not just a Full Stack Developer; I'm a Muslim problem solver with a deep passion for backend development. With experience in Java (Spring Boot), NestJS, Node.js, Laravel, and other powerful frameworks, I thrive on tackling complex challenges and building scalable, efficient solutions. From building robust backend systems to crafting intuitive front-end experiences with JavaScript, React.js, and React Native, I take pride in leveraging technology to bring ideas to life All in the will of Allah"
  ),
  resumeLink:
    "https://www.cvwizard.com/d/2npsVYwFfcleYbOOyX07kf/view", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/ashrafutuyubahe",
  linkedin: "https://www.linkedin.com/in/tuyubahe-ashrafu-2073482a4/",
  gmail: "ashraftuyubahe001@gmail.com",
  
 
 
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section
const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Frontend / User Interfaces for web and mobile applications"
    ),
    emoji("⚡ Build Progressive Web Applications (PWA) using SPA frameworks"),
    emoji("⚡ Integration of third-party services such as Firebase, AWS, Digital Ocean"),
    
    // Backend Engineering
    emoji("⚡ Design and develop scalable RESTful & GraphQL APIs"),
    emoji("⚡ Implement authentication & security best practices (JWT, OAuth, OpenID)"),
    emoji("⚡ Database design and management (SQL & NoSQL)"),
    emoji("⚡ Implement microservices architecture and event-driven systems"),

    // DevOps
    emoji("⚡ Automate deployment with CI/CD pipelines (GitHub Actions, GitLab CI, Jenkins)"),
    emoji("⚡ Deploy and manage cloud infrastructure (AWS, Google Cloud, Azure)"),
    emoji("⚡ Work with containerization technologies (Docker, Kubernetes)"),
    emoji("⚡ Infrastructure as Code (Terraform, Ansible)"),
    emoji("⚡ Set up monitoring & logging with Prometheus, Grafana, ELK Stack")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    // Frontend
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "SASS",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "ReactJS",
      fontAwesomeClassname: "fab fa-react"
    },

    // Backend
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Express.js",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "GraphQL",
      fontAwesomeClassname: "fas fa-project-diagram"
    },
    {
      skillName: "SQL & NoSQL",
      fontAwesomeClassname: "fas fa-database"
    },

    // DevOps
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Kubernetes",
      fontAwesomeClassname: "fas fa-cube"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "CI/CD",
      fontAwesomeClassname: "fas fa-tools"
    },
    {
      skillName: "Terraform",
      fontAwesomeClassname: "fas fa-code-branch"
    },
    {
      skillName: "Linux Server Management",
      fontAwesomeClassname: "fas fa-terminal"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};



// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Rwanda Coding Academy",
      logo: require("./assets/images/RCA.png"),
      subHeader: "Software Programmign and Embedded Systems",
      duration: "September 2017 - April 2019",
      desc: "Attended RCA in 20219. where I gained hand-on skils about software Engineering and Cybersecurity",
      descBullets: [
        "Gained on-market skills about software developmennt but also Cybersecurity",
        
      ]
    },
    {
      schoolName: "Ecole Saint Jean Bosco De SIMBI",
      logo: require("./assets/images/SIMBI.png"),
      subHeader: "Ordinary Level",
      duration: "September 2014 - April 2018",
      desc: "I studied at ES.SIMBI where I  gained knowledge about the science courses and  this helped me pass my national exam and got admitted At RCA",
      descBullets: [""]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%"
    },
    {
      Stack: "Backend Development",
      progressPercentage: "96%"
    },
    
    {
      Stack: "Database Management",
      progressPercentage: "85%"
    },
    {
      Stack: "RESTful & GraphQL APIs",
      progressPercentage: "88%"
    },
    
    {
      Stack: "Microservices Architecture",
      progressPercentage: "88%"
    },
    {
      Stack: "Cloud Computing (AWS, GCP, Azure)",
      progressPercentage: "85%"
    },
    {
      Stack: "Containerization (Docker)",
      progressPercentage: "95%"
    },
    {
      Stack: "CI/CD Pipelines (Jenkins, GitHub Actions, GitLab CI)",
      progressPercentage: "95%"
    },
    {
      Stack: "Infrastructure as Code (Terraform, Ansible)",
      progressPercentage: "90%"
    },
    {
      Stack: "Monitoring & Logging (Prometheus, Grafana, ELK Stack)",
      progressPercentage: "75%"
    },
    {
      Stack: "Server Management & Linux Administration",
      progressPercentage: "80%"
    },
    {
      Stack: "Networking & Load Balancing",
      progressPercentage: "76%"
    }
  ],

  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Etix",
      companylogo: require("./assets/images/Etix.png"),
      date: "June 2020 – Present",
      desc: "I am currently working at Etix where I play a  Software Engineer Role ",
      descBullets: [
        "I help the team  to build first and scalable backend arcitecture",
        "I am WOrking as Team Lead on the e-ticketing App the company is currently working on "
      ]
    },
    {
      role: "Backend Developer",
      company: "Mediconnect",
      companylogo: require("./assets/images/mediconnect.png"),
      date: "May 2022 – May 2023",
      desc: "I helped  my team  Mediconnect  to deliver the first application and  we managed  to secure the best position in RCA Hackathon."
    },
    {
      role: "Backend Engineer Intern",
      company: "CodeAlpha",
      companylogo: require("./assets/images/CodeAlpha.png"),
      date: "Jan 2025 – feb 2025",
      desc: "Worked as Backend Engineer At CodeAlpha where I  helped  to developer scalable backend systems"
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/Etix.png"),
      projectName: "vuduka app",
      projectDesc: "Vuduka is a user-friendly platform designed to simplify ticket booking and management, offering seamless payment integration and real-time updates for a smooth travel experience.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://vuduka.netlify.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/blogsite.png"),
      projectName: "Your-Voice",
      projectDesc: "blogging platform where everyone voice is allowed to make impact",
      footerLink: [
        {
          name: "View Codebase",
          url: "https://github.com/ashrafutuyubahe/Blogsite"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "CodeAlpa Best Intern",
      subtitle:
        "I have been offered recomendation letter from codeAlpha as best backend intern ",
        image: require("./assets/images/OfferLetter.png"),
     
      footerLink: [
        
        {
          name: "Offer Letter",
          url: "https://drive.google.com/file/d/1MNlXlZwYVoy1O9syKcgQ3OgS1b-hxGGm/view?usp=sharing"
        }
        
      ]
    },
    {
      title: "Backend Intern at CodeAlpha",
      subtitle:
        "I have made scalable backend systems at codeAlpha and also  I earned a certificate to confirm it .",
      image: require("./assets/images/completion_certi.png"),
      imageAlt: "",
      footerLink: [
        {
          name: "certificate of completion",
          url: "https://drive.google.com/file/d/1D48TMZMtCmFB7iz3uUW6hz1uf91Lg_C-/view?usp=sharing"
        }
      ]
    },

    {
      title: "stand out as Spring Boot Developer",
      subtitle: " Certifcate of completion as springboot Developer from Amigoscode",
      image: require("./assets/images/springboot.png"),
      imageAlt: "amigoscode Logo",
      footerLink: [
        {name: "Certification", url: ""},
        
      ]
    },
    
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    },
   
  ],
  display: false // Set false to hide this section, defaults to true
};



// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+250794901362",
  email_address: "ashraftuyuabahe001@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "https://x.com/AshrafTuyubahe", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
